export const ADVERTISING_CATALOG_URL = '/advertising/catalog';

const ADVERTISING_SHOPS_URL = '/advertising/catalog/shops';

export const ADVERTISING_PRODUCTS_URL = '/advertising/catalog/products';

export const CATALOG_URLS = [
    ADVERTISING_CATALOG_URL,
    ADVERTISING_SHOPS_URL,
    ADVERTISING_PRODUCTS_URL,
];
